import BulkAddIngredients from './BulkAddIngredients';
export default BulkAddIngredients;
